var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('InfoBoxWrapper',{class:{
		'jw-info-box--trailer-playing': _vm.isBackdropTrailerPlaying,
		'jw-info-box--no-card': !_vm.hasBackdropContent,
	}},[_c('div',{staticClass:"jw-info-box__container"},[_c('div',{staticClass:"jw-info-box__container-sidebar"},[_c('TitleSidebar',{attrs:{"title":_vm.title,"titleContentType":_vm.titleContentType,"additionalContexts":_vm.additionalContexts,"influencedSponsoredAd":_vm.influencedSponsoredAd}})],1),_c('div',{staticClass:"jw-info-box__container-content"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }